import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {PeOsContextComponent} from './peOsContext.component';

@NgModule({
    imports: [
    ],
    declarations: [PeOsContextComponent],
    providers: [],
    exports: [PeOsContextComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})

export class PeOsModule {

}
